import React, { Component } from "react";
import "./Branch.css";
import { Label, ListGroup ,ListGroupItem ,ButtonGroup ,Button,Jumbotron,Well} from "react-bootstrap";
import { API } from "aws-amplify";
import Moment from 'react-moment';
import AUTHMD from '../md/HomeAuthenticated.md'
import UNAUTHMD from '../md/HomeUnAuthenticated.md'
import HeatMap from "react-heatmap-grid"

import ReactMarkdown from 'react-markdown/with-html'
import Timeline from "react-time-line"

  const events =   [
     {
      "text": "Bedroom Door :Closed",
      "ts": 1570476241064
     },
     {
      "text": "Main Door:Closed",
      "ts": 1570476226409
     },
     {
      "text": "Main Door:Open",
      "ts": 1570476222612
     },
     {
      "text": "Lounge Internal Door :Closed",
      "ts": 1570476214916
     },
     {
      "text": "Bathroom Door :Closed",
      "ts": 1570474873361
     },
     {
      "text": "Bathroom Door :Open",
      "ts": 1570474855373
     },
     {
      "text": "Main Door:Closed",
      "ts": 1570474853609
     },
     {
      "text": "Main Door:Open",
      "ts": 1570474776844
     }
    ]

function online(d){
  let last_seen=new Date(d.last_seen)
  if(d.online===1)
    return (<Label className="pull-right" title={"Last msg:"+last_seen.toLocaleString()}>Online</Label>)
  return

}


function icon_from_sensor_type(name_string){
	var name=name_string.toLowerCase()
  var default_input_icon='fa-exclamation'
	//Default icon
	var r=default_input_icon
	//first item is the icon you want followed by a list of words to associate to that icon
	var iconlist=[
      ['fa-close','disable','No input'],
			['fa-bed','bed','bedroom','epilepsy','enuresis','bed wet','enuresis sensor'],
			['fa-volume-up','audio','mic','microphone','sound','sound detector','noise detector','shout detector'],
			['fa-paw','motion','motion detector','PIR','movement','movement sensor','motion sensor'],
			['fa-tint','flood'],
			['fa-sign-out','door'],
			['fa-windows','window','windows'],
			['fa-square','floor'],
			['fa-bell','buzzer','beep','bell','beep test', 'buzz'],
			['fa-lightbulb-o','lamp on','light on','lights on','lamp on','light off','lamp off','lights off'],
			['fa-phone','make call','call'],
			['fa-mobile','sms','text','send text','send sms'],
			['fa-envelope-o','email','mail','send email','send mail'],
			['fa-archive','log'],
			['fa-times','no action'],
      ['fa-thermometer-half','Temperature Sensor'],
      ['fa-square','breakbeam']

		]

	//convert everything to lowercase
	iconlist=JSON.parse(JSON.stringify(iconlist).toLowerCase())

	iconlist.forEach(function(e){
		if(e.indexOf(name)!==-1){
			r=e[0];
		}
	});

  if (r==default_input_icon){
    if (name.includes("fridge") || name.includes("freezer") || name.includes("temperature") )
      r='fa-thermometer-half'
  }
	return r;
}


function SensorCount(props){
//  console.log(props.data)
  let d=props.data
  let xLabels=new Array(props.heat.data.length)
  //console.log("xLab")
  let callback=props.callback

  xLabels=["","","","3AM","","","6AM","","","9AM","","","12AM","","","3PM","","","6PM","","","9PM","",""]
//  console.log(xLabels)
  let yLabels=[1]
  let hdata=[props.heat.data]
  if(hdata[0].length!=24){
    hdata[0]=datapad(hdata[0],24)
  }
  let icon_name=icon_from_sensor_type(d.key)
  let temp=(<div className="sensorSum"><i className={"fa "+icon_name+" fa-2x"}></i></div>)
  return (<div className="heatMap" >


  <HeatMap  xLabels={xLabels} yLabels={[temp]} data={hdata} onClick={(x,y,e,v)=>callback(x,y,d.key,"input") } cellStyle={(background, value, min, max, data, x, y) => ({
      background: `rgba(50, 159, 255, ${1 - (max - value) / (max - min)})`,
      fontSize: "11px",
    })} />
    <span>{d.key.toLocaleUpperCase()}:{d.doc_count}</span>
  </div>)
}


function datapad(data,length){
  for(let i=data.length;i<length;i++){
    data.push(0)
  }
  return data
}


function EventCount(props){
  //console.log(props.data)
  let d=props.data
  let callback=props.callback
let xLabels=new Array(props.heat.data.length)
//  console.log("xLab")
 xLabels=["","","","3AM","","","6AM","","","9AM","","","12AM","","","3PM","","","6PM","","","9PM","",""]
  //console.log(xLabels)
  let hdata=[props.heat.data]
  if(props.heat.data.length==0){
    return("")
  }

  if(hdata[0].length!=24){
    hdata[0]=datapad(hdata[0],24)
  }
  let xLabelsShow=[false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false]
  let yLabels=[1]
  let icon_name=icon_from_sensor_type(d.key)
  let temp=(<div className="eventSum"></div>)



  return (<div className="eventSum heatMap">



  {d.key=="0"?(
  <HeatMap className={d.doc_count} xLabels={xLabels} yLabels={["None"]} data={hdata} onClick={(x,y,e,v)=>callback(x,y,d.key,"event") } cellStyle={(background, value, min, max, data, x, y) => ({
      background: `rgba(159, 159, 159, ${1 - (max - value) / (max - min)})`,
      fontSize: "11px",
    })} />):("")}

  {d.key=="1"?(
  <HeatMap xLabels={xLabels} yLabels={["Green"]} data={hdata} xLabelsVisibility={xLabelsShow} onClick={(x,y,e,v)=>callback(x,y,d.key,"event")} cellStyle={(background, value, min, max, data, x, y) => ({
    background: `rgba(50, 255, 85, ${1 - (max - value) / (max - min)})`,
    fontSize: "11px",
  })} />):("")}

  {d.key=="2"?(
  <HeatMap xLabels={xLabels} yLabels={["Amber"]} data={hdata}  xLabelsVisibility={xLabelsShow}  onClick={(x,y,e,v)=>callback(x,y,d.key,"event")} cellStyle={(background, value, min, max, data, x, y) => ({
    background: `rgba(255,173, 50, ${1 - (max - value) / (max - min)})`,
    fontSize: "11px",
  })} />):("")}

  {d.key=="3"?(
  <HeatMap xLabels={xLabels} yLabels={["Red"]} data={hdata}  xLabelsVisibility={xLabelsShow} onClick={(x,y,e,v)=>callback(x,y,d.key,"event")} cellStyle={(background, value, min, max, data, x, y) => ({
    background: `rgba(255, 50, 50, ${1 - (max - value) / (max - min)})`,
    fontSize: "11px",
  })} />):("")}



  </div>)
}
//<HeatMap xLabels={xLabels} yLabels={[temp]} data={hdata}  cellStyle={(background, value, min, max, data, x, y) => ({



function AltiomGrid(props){
  //console.log(props.data)
  let d=props.data
  return (<p className="item" title={d.IP+" / "+d.altid}>
        <a href={"/a/"+d.altid}><b>{d.UNIT}</b>:<span>{d.ROOM}</span></a>
      {online(d)}
        </p>)
}

export default class Branch extends Component {
    constructor(props) {
      super(props);
      this.state = {
        md_auth:null,
        md_unauth:null,
        name:"",
        isLoading:true,
        heatLoading:true,
        data:[],
        summary:[],
        eventslevels:[],
        day:0,
        indepth:false,
        indepthTitle:"In depth",
        timestring:"Today",
        detailYlabels:[],
        detailYlabelsID:[],
        detailHeatmap:[[]],
        detailXlabels:["","","","","","","","","","","","","","","","","","","","","",""],
        raw:[],
        inputevents:[],
        inputEventAltiom:"",
        rawLoading:true,
        hideheatmap:false
      };
    }


    reset(){

      this.setState({"day":0})
      this.getDayData(0)


    }


    today(){
      let time=new Date()
      time.setHours(0)
      time.setMinutes(0)
      time.setSeconds(0)
      time.setMilliseconds(0)
      return time.getTime()
    }

    forward(){
      console.log("Forward")
      let day=this.state.day
      day=day+1
      this.setState({day:day})
      this.setState({indepth:false})
      this.setState({rawLoading:true})
      this.getDayData(day)

    }

    backward(){
      console.log("Backward")
      let day=this.state.day
      day=day-1
      this.setState({day:day})
      this.setState({indepth:false})
      this.setState({rawLoading:true})
      this.getDayData(day)
    }


    async getDayData(day){
      let time=this.today()
      time=time+(24*3600000*day)
      console.log("Get Day Data"+day)
      this.setState({heatLoading:true})

      //Set the data to all 0's while its loading
  /*    let loadingEvents=this.state.events
      for( let key in loadingEvents){
        console.log(key)
        loadingEvents[key].data=blankdata
      }

      let d={
        "events":loadingEvents
      }
      console.log(loadingEvents)
      this.setState(d)
      console.log(this.state)*/



      let datetime=new Date(time)
      if(day==-1){
        this.setState({timestring:"Yesterday "+datetime.toLocaleDateString()})
        this.setState({hideheatmap:false})
      }
      else if(day>0){
        this.setState({timestring:"Future! "+datetime.toLocaleDateString()})
        this.setState({hideheatmap:true})
      }
      else if (day==0) {
        this.setState({timestring:"Today"})
        this.setState({hideheatmap:false})
      }
      else{
          this.setState({timestring:datetime.toLocaleDateString()})
          this.setState({hideheatmap:false})
      }

      const data = await this.getdata(time);
      console.log(data)
      this.setState(data)
      this.setState({heatLoading:false})
    }



    async componentWillMount() {


      const data = await this.getdata(this.today());
      console.log(data)

  //  data["inputs"]= {"motion": {"data": [10, 2, 10, 18, 30, 11, 7, 4, 0, 0, 4, 10, 2, 6, 4, 22, 25, 16, 35, 23, 36, 21, 10, 21, 5]}, "door": {"data": [21, 8, 32, 13, 23, 39, 61, 62, 0, 0, 0, 2, 0, 1, 3, 21, 77, 45, 32, 71, 58, 43, 31, 51, 14]}}

  //  data["events"]= {"0": {"data": [0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]},
    //                 "1": {"data": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]},
    //                 "2": {"data": [0, 0, 0, 2, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]},
      //               "3": {"data": [4, 1, 0, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 6, 1, 2, 3, 2, 0, 1, 7, 6]}}




data["eventslevels"]=[{"key":"0","doc_count":0},{"key":"1","doc_count":0},{"key":"2","doc_count":0},{"key":"3","doc_count":0}]
      this.setState(data)
      this.setState({isLoading:false})
      this.setState({heatLoading:false})
      console.log(this.state)
    }

    getdata(t, mode="",sensor="",altid="") {

      var data = {
        'queryStringParameters': {
            branch:this.props.match.params.id,
            time:t,
            mode:mode,
            sensor:sensor,
            altid:altid
        }
      }


      return API.get("AltiomData", "/altiom",data);
    }

    callback=async(x,y,type,e)=>{
      let count=0
        console.log("-------")
        console.log(x)
        console.log(y)
        console.log(type)
        console.log(e)
        console.log("count")
      if(e=="input"){
        count=this.state.inputs[type].data[x]
        console.log(count)
      }
      if(e=="event"){
        count=this.state.events[type].data[x]
          console.log(count)
      }
      console.log(count)
      let time=this.today()
      console.log(time)
      time=time+24*3600000*this.state.day
      time=time+x*3600000
      this.detailtime=time
      this.detailtype=type
      if(count>0 && e!="event"){
          //There is some data that can be gathered.
          //give me all the breakbeam activations per room for that hour
        //  let time=this.today()
        //  console.log(time)
      //    time=time+24*3600000*this.state.day
        //  time=time+x*3600000
          this.setState({indepthTitle:type.toLocaleUpperCase()+" "+new Date(time).toLocaleDateString() +" @ "+new Date(time).toLocaleTimeString()})
          this.setState({"rawLoading":true})
          var data = await this.getdata(time,"indepth",type);
          console.log(data)
          //Data needs combining so heatmap is correct over the whole section.

          var detailYlabels=[]
          var detailYlabelsID=[]
          var detailHeatmap=[]
          var heatmapDate=new Date(time)
          var hour=heatmapDate.getHours()
          var detailXlabels=[hour+":00",
                              "",
                              "",
                              "",
                              "",
                              "",
                              hour+":15",
                              "",
                              "",
                              "",
                              "",
                              "",
                              hour+":30",
                              "",
                              "",
                              "",
                              "",
                              "",
                              hour+":45",
                              "",
                              "",
                              "",
                              "",
                              hour+":59"]


          for(let item in data.detail){
            detailYlabels.push(this.nameFromAltid(item))
            detailYlabelsID.push(item)
            detailHeatmap.push(data.detail[item].data)

          }


          let d={
            detailYlabelsID:detailYlabelsID,
            detailYlabels:detailYlabels,
            detailHeatmap:detailHeatmap,
            detailXlabels:detailXlabels
          }
          console.log(d)
          this.setState(d)

          this.setState({indepth:true})
          //The altids also need changing to room-alt name

      }
      else{
        console.log("Get Raw Data")
        this.setState({indepth:false})
        this.setState({indepthTitle:new Date(time).toLocaleDateString() +" @ "+new Date(time).toLocaleTimeString()})
        //For events do a timeline of the event with colourisation and description.
        console.log(time)
        console.log(type)
        this.setState({"rawLoading":true})
        var data = await this.getdata(time,"rawevents",type);
        //for the inputs can i do a small chart with details?
        var ldata=data.detail
        var temp=[]
        console.log(data)
        for(var i=0;i<ldata.hits.length;i++){
          console.log(ldata.hits[i]["_source"])
          ldata.hits[i]["_source"]["altname"]=this.nameFromAltid(ldata.hits[i]["_source"]["altid"])
          temp.push(ldata.hits[i]["_source"])
        }
        this.setState({"raw":temp})
        this.setState({"rawLoading":false})


      }



    }

    async inputHeatClick(x,y,z){
        console.log(this.state.detailYlabels[y])
      console.log(this.state.detailYlabelsID[y])
      this.setState({inputEventAltiom:this.state.detailYlabels[y]})
      var data = await this.getdata(this.detailtime,"rawinputs",this.detailtype,this.state.detailYlabelsID[y]);
      console.log(data)
      //need the ALT ID rather than the Altiom name
      //Do the chart request for an hour or do 24 hours?
this.setState({inputevents:data.detail})


    }


    nameFromAltid(altid){

      let altioms=this.state.data
      if("altids" in this){
            return this.altids[altid]
      }
      else{

        let altids={}
        for(let i=0;i<altioms.length;i++){
          altids[altioms[i]["_id"]]=altioms[i]["_source"]["UNIT"]+" "+altioms[i]["_source"]["ROOM"]
        }
        this.altids=altids
        return this.altids[altid]
      }


    }


    online(data){
      console.log(data)
      if(data===1)
        return (<span className="green">Online</span>)
      if(data===0)
        return (<span className="red" >Offline</span>)

    }

    logitem(data,index){
      let type="Unknown"
      let message=""
    //  console.log("LOG ITEM "+index)
      let altname=""
      if("altname" in data){
        altname=data.altname
      }
      switch(data.type){
        case 0xA0000:
          return ""

        case 0xA0001:
            message=(<span><b>Input:</b>{data.name}:{data.state_text}</span>)
            break;
        case 0xA0002:
            let levels=["None" ,"Green","Amber", "Red"]
            let label=(<Label className={"alert"+levels[data.level]}>{levels[data.level]}</Label>)
            if(data.state==1){
              if(data.name=="Temperature Alert"){
                  message=<span><b>Event:</b>{data.name} <b>True</b> {label}<p>{data.Description}</p></span>
              }
              else{
                message=(<span><b>Event:</b>{data.name} <b>True</b> {label}</span>)
              }
            }
            if(data.state==0){
              if(data.name=="Temperature Alert"){
                  message=<span><b>Event:</b>{data.name} <b>False</b> {label}<p>{data.Description}</p></span>
              }
              else{
              message=(<span><b>Event:</b>{data.name} <b>False</b> {label}</span>)
              }
            }
            break;
        case 0xA0003:
            type="Var Data"
            if(data.value==0)
              message=(<Label>SAFE MODE OFF</Label>)
            else
              message=(<Label>SAFE MODE ON</Label>)
            break;
      }
      var time=new Date(data.time)


      return (<p key={index}title={JSON.stringify(data)} ><small>{time.toLocaleTimeString()}</small>&nbsp;{altname} {message}</p>)

    }


    render() {
      let temp=this
      return (
          <div className="Home">
          <Jumbotron>
          <Button className="pull-right" onClick={()=>this.props.history.goBack()}>Back</Button>
            {this.state.isLoading ? (<h2>Loading...</h2>):(
              <div>
              <h2>{this.state.name}</h2>
              <br/>
              <h3>Recent Activity <span>({this.state.timestring})</span>
                  <span className="pull-right">
                    <Button  onClick={()=>this.backward()}><i className="fa fa-chevron-left"></i></Button>
                    <Button  onClick={()=>this.reset()}>Today</Button>
                    <Button  onClick={()=>this.forward()}><i className="fa fa-chevron-right"></i></Button>
                  </span>
              </h3><br/><br/>
              <div className="heightTrans">
              {this.state.summary.map((l,i)=><SensorCount key={"eventHeat"+l.key} data={l} heat={this.state.inputs[l.key]} callback={this.callback}>{l.key}:{l.doc_count}</SensorCount>)}
              </div>
              <br/>
              {this.state.hideheatmap==true ? (<div></div>):(
                <div>
              <h3>Events</h3>
              {this.state.eventslevels.map((l,i)=><EventCount key={"eventHeat"+l.key} data={l} heat={this.state.events[l.key]} callback={this.callback}>{l.key}:{l.doc_count}</EventCount>)}
              </div>)}
              <br/>

              <br/>
              {this.state.indepth ? (<div><h3>Breakdown (1h)</h3><span>{this.state.indepthTitle}</span>
                {this.state.hideheatmap==true ?(""):(
                <HeatMap xLabelWidth={150} xLabels={this.state.detailXlabels} yLabels={this.state.detailYlabels} data={this.state.detailHeatmap} onClick={(x,y)=>this.inputHeatClick(x,y)} cellStyle={(background, value, min, max, data, x, y) => ({
                    background: `rgba(50, 159, 255, ${1 - (max - value) / (max - min)})`,
                    fontSize: "11px",
                  })} />
                )}
                  <br/>
                  <h4>{this.state.inputEventAltiom}</h4>
                  <Timeline items={this.state.inputevents} />

                </div>):("")}

                {this.state.rawLoading==false ? (
                  <div>
                  <hr/>
                    <h3>Logs (1h)</h3><span>{this.state.indepthTitle}</span>
                    <Well>
                    {this.state.raw.map(
                      (d, i) =>
                            <span key={i}>
                            {this.logitem(d,i)}
                            </span>
                    )}
                    </Well>
                  </div>
                ):("")}


              <br/>
              <hr/>
              <div className="flex-grid">
              {this.state.data.map((l,i)=><AltiomGrid className="item" key={i} data={l._source}>ALTIOM</AltiomGrid>)}
              </div>
              </div>
)
            }
            </Jumbotron>
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Branch.js